import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export const MidCTA = () => {
  return <section className="py-10 md:py-16 border-y border-brand-gold/20 bg-brand-gold/5" data-id="element-96">
      <div className="container px-4 mx-auto text-center max-w-4xl" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-98">
          <h2 className="mb-5 md:mb-6 text-2xl font-bold md:text-4xl" data-id="element-99">
            Empezá a aplicar estas estrategias{' '}
            <span className="text-gradient-gold" data-id="element-100">hoy mismo</span>
          </h2>
          <Button href="#pricing" className="shadow-lg shadow-brand-gold/20" data-id="element-101">
            Acceder a Marketing PRO ahora
          </Button>
        </motion.div>
      </div>
    </section>;
};